export const FIELDS = {
    REQUISICAO: 'requisicao',
    EQUIPAMENTO: 'equipamento',
    OBSERVACAO: 'observacao',
    DADOS_GERAIS: 'DADOS_GERAIS',
    DADOS_EXAME: 'DADOS_EXAME',
    IMAGENS: 'IMAGENS'
};